import Vue from 'vue'
import i18n from '@/lang' // internationalization

const getTranslateString = str => {
  const placeholders = str.match(/\[\[(.*?)\]\]/g)

  if (placeholders) {
    placeholders.forEach(placeholder => {
      const key = placeholder.slice(2, -2) // Remove [[ and ]]
      const translation = i18n.t('variables.' + key)
      str = str.replace(placeholder, translation)
    })
  }

  return str
}

const DescriptionList = Vue.extend({
  name: 'DescriptionList',
  props: {
    descObject: {
      type: Object,
      required: true
    }
  },
  data() {
    return {}
  },
  methods: {
    getTranslateString
  },
  // <p style="margin: 4px 0;" v-for="item in Object.keys(descObject)" :key="item">- {{ $t('variables.' + item) }}:
  template: `<div>
  <p style="margin: 8px 0;" v-for="item in Object.keys(descObject)" :key="item">- {{ getTranslateString(item) }}:
      <span v-if="typeof descObject[item] != 'object'">{{ getTranslateString(descObject[item]) }}</span>
      <DescriptionList v-else style="padding-left: 12px" :descObject="descObject[item]"></DescriptionList>
    </p>
  </div>
  `
})

const CellDescription = Vue.extend({
  components: {
    DescriptionList
  },
  data() {
    return {
      description: null
    }
  },
  beforeMount() {
    // this.description =
    //   JSON.parse(this.params.value.replace(/\[\[(.*?)\]\]/g, '$1')) || {}

    this.description = JSON.parse(this.params.value)
  },
  methods: {
    getTranslateString
  },
  template: `<div>
    <p style="margin: 8px 0; font-weight: 600">{{ getTranslateString(description.title) }}</p>
    <DescriptionList :descObject="description.details" />
  </div>`
})

export { CellDescription }
